define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_EMBED_HEIGHT_PERCENTAGE = 50;
    const DEFAULT_EMBED_WIDTH_PERCENTAGE = 50;

    /**
     * Model for an embed widget.
     *
     * @class EmbedWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("EmbedWidget", {

        defaults: _.defaults({
            type: "embed",
            // scaleMode: WidgetScaleMode.STRETCH,
            width: DEFAULT_EMBED_WIDTH_PERCENTAGE,
            height: DEFAULT_EMBED_HEIGHT_PERCENTAGE,
            url: ""
        }, AbstractWidgetModel.prototype.defaults),

        fitToScene() {
            this.set({
                left:     0,
                top:      0,
                rotation: 0,
                width:    100,
                height:   100
            });
        },

        /**
         * Returns true if this model has a - perhaps invalid - non-empty url associated with it, false otherwise.
         *
         * @returns {Boolean} True if this model has a non-empty url, false otherwise.
         */
        hasUrl() {
            return !!this.get("url");
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/embedWidget/EmbedWidgetModel.js